<template>
  <div class="form-group">
    <div class="row">
      <div class="col-xs-12">
        <v-textarea name="presentation" title="Présentation de la structure" v-model="newPresentation"></v-textarea>
        <span :class="type">{{(max - newPresentation.length)}} caractères restant sur {{max}}</span>
      </div>
    </div>
    <div>
      <button type="submit" class="btn green" @click="send">Valider les informations</button>
    </div>
  </div>
</template>

<script>
export default {

  name: 'OfficeInformationForm',
  props: {
    office: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      newPresentation: this.office.presentation,
      max: 730,
    }
  },
  methods: {
    async send() {
      await axios.put(`/office/${this.office.id}`, { presentation: this.newPresentation })

      this.$snotify.success('Présentation mise a jour')
    }
  },
  computed: {
    type() {
      if(this.newPresentation.length<this.max*0.2) {
        return 'alert-warning';
      } else if(this.newPresentation.length>this.max) {
        return 'alert-danger';
      } else if(this.newPresentation.length*1.3>this.max) {
        return 'alert-warning';
      } else {
        return 'alert-success';
      }
    }
  }
};
</script>

<style lang="css" scoped>
  .btn{
    margin-top: 1rem;
  }
</style>
